import $ from 'jquery';
import Utils from "./utils";

class Listing {
  constructor() {
    this.singlePage = document.querySelector('.js-clb-single-page');

    if (!this.singlePage) {
      return;
    }

    this.singleRelatedPosts = this.singlePage.querySelectorAll('.js-clb-related-posts');
    this.singleRelatedPostsSearchTitle = this.singlePage.querySelector('.js-clb-single-page-title');
    this.isExpired = parseInt(this.singlePage.dataset.expired, 10);
    this.isMine = parseInt(this.singlePage.dataset.mine, 10);
    this.enquiryFormId = parseInt(this.singlePage.dataset.enquiryForm, 10);

    if (this.isExpired === 1) {
      return;
    }

    this.reportAction = 'km_clb_save_report';
    this.pageSlug = window.location.pathname.replace(/\/+$/, '').split('/').pop();
    this.tableCategory = this.singlePage.dataset.brandCategory;

    this.contactDetailsHandler();

    if ( ! this.tableCategory  ) {
      return;
    }

    this.reportViewsHandler();
    this.relatedPosts();
  }

  contactDetailsHandler() {
    this.showDetailsButton = document.querySelector('.js-show-details');
    this.contactDetails = document.querySelector('.js-contact-details');

    if (!this.showDetailsButton || !this.contactDetails) {
      return;
    }

    $(document).on('gform_confirmation_loaded', (event, formId) => {
      if (this.enquiryFormId === parseInt(formId, 10)) {
        this.makeAjaxRequest('enquiries');
      }
      // code to be triggered when the confirmation page is loaded
    });

    this.email = this.contactDetails.querySelector('.js-clb-email');
    this.formPopup = this.contactDetails.querySelector('.js-clb-form-popup');

    this.showDetailsButton.addEventListener('click', () => {
      this.contactDetails.classList.remove('hidden');
      this.showDetailsButton.classList.add('pointer-events-none');
      this.showDetailsButton.setAttribute('disabled', 'disabled');

      if (!this.isMine) {
        this.makeAjaxRequest('reveals');
      }
    });

    if (this.email && this.formPopup) {
      this.formPopupClose = this.formPopup.querySelector('.js-clb-form-popup-close');

      this.email.addEventListener('click', () => {
        this.formPopup.classList.add('is-open');
      });

      if (this.formPopupClose) {
        this.formPopupClose.addEventListener('click', () => {

          const confirmationLoaded = this.formPopup.querySelector('.gform_confirmation_wrapper');

          if (confirmationLoaded) {
            window.location.reload();
          } else {
            this.formPopup.classList.remove('is-open');
          }
        });
      }
    } else {
      this.email.remove();
    }
  }

  reportViewsHandler() {
    if (this.isMine) {
      return;
    }

    setTimeout(() => {
      this.makeAjaxRequest('views');
    }, 1000);
  }

  makeAjaxRequest = async (type) => {
    try {
      const response = await Utils.ajaxRequest(this.reportAction, {
        type,
        slug: this.pageSlug,
        table: this.tableCategory,
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  relatedPosts() {
    if ( this.singleRelatedPosts.length ) {
      this.singleRelatedPosts.forEach((singleRelatedPostsItem) => {
        Utils.ajaxRequest('km_clb_get_related_posts', {
          s: this.singleRelatedPostsSearchTitle.textContent,
          keywords: singleRelatedPostsItem.dataset.keywords,
          offset: singleRelatedPostsItem.dataset.offset,
          no_manufacturer_or_model: singleRelatedPostsItem.dataset.no_manufacturer_or_model,
        }).then((response) => {
          singleRelatedPostsItem.innerHTML = response.content;
        });
      });
    }
  }
}

export default Listing;
